import { render, staticRenderFns } from "./NumberItemPerPage.vue?vue&type=template&id=aa597ef2&scoped=true&"
import script from "./NumberItemPerPage.vue?vue&type=script&lang=js&"
export * from "./NumberItemPerPage.vue?vue&type=script&lang=js&"
import style0 from "./NumberItemPerPage.vue?vue&type=style&index=0&id=aa597ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa597ef2",
  null
  
)

export default component.exports